import React from "react";
import { Route, Routes } from "react-router-dom";
import { AppBar, Toolbar, Typography, Container, Box } from '@mui/material';
import Home from "./pages/Home";
import Chat from "./pages/Chat";
import ProntuarioAsync from "./pages/ProntuarioAsync";
import './App.css';
import FichaASA from "./pages/FichaASA";

function App() {
  return (
    <div className="App">
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">
            UNIANEST - Prontuário Eletrônico
          </Typography>
        </Toolbar>
      </AppBar>
      <Container>
        <Box my={4}>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/prontuario-async" element={<ProntuarioAsync />} />
            <Route path="/" element={<FichaASA />} />
          </Routes>
        </Box>
      </Container>
    </div>
  );
}

export default App;
